import methods from './methods'
import scheme from './scheme'
import components from './components/index.js'

export default {
  methods,
  scheme,
  components
}
